// extracted by mini-css-extract-plugin
export default {"link":"Footer_link__fXbK+","footer":"Footer_footer__Am2TL","footerItem":"Footer_footerItem__DojPp","iconWrap":"Footer_iconWrap__+WzwN"};